import { useQuery } from '@gogame/query';

import { loadCancelationStorm } from '../sources/playground';
import { details } from './queryKeyFactory';

const CANCELATION_STORM_PARAMS = {
  id: 11001,
  campaignId: 1360160,
};
export const useLoadCancelationStorm = (params = CANCELATION_STORM_PARAMS) => {
  return useQuery(
    details(params.id),
    (_, { signal }) => loadCancelationStorm(params, { signal }),
    {
      enabled: true,
    }
  );
};
